// extracted by mini-css-extract-plugin
export default {"adInformations":"AdInformations_adInformations__c664r"};